import { Link } from 'react-router-dom';
import Routes from '~/routes/routes';
import { BreadcrumbProps } from 'antd';
import { ReactElement, ReactNode } from 'react';
import { AiFillHome, AiFillFolderOpen, AiOutlineUpload, AiOutlineSetting } from 'react-icons/ai';
import { HiOfficeBuilding } from 'react-icons/hi';

export interface BreadcrumbItem {
  title: ReactNode;
  href?: string;
  icon?: ReactElement;
}

export const createBreadcrumbItems = (items: BreadcrumbItem[]): BreadcrumbProps['items'] => {
  return items.map((item, index) => {
    const isLast = index === items.length - 1;

    return {
      title: isLast || !item.href ? (
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {item.icon}
          {item.title}
        </span>
      ) : (
        <Link to={item.href} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {item.icon}
          {item.title}
        </Link>
      ),
    };
  });
};

export const commonBreadcrumbs = {
  home: { title: 'Trang chủ', href: Routes.HOME, icon: <AiFillHome style={{ fontSize: '16px' }} /> as ReactElement },
  projects: { title: 'Dự án', href: Routes.PROJECT, icon: <AiFillFolderOpen style={{ fontSize: '16px' }} /> as ReactElement },
  uploadTasks: { title: 'Lượt tải lên', icon: <AiOutlineUpload style={{ fontSize: '16px' }} /> as ReactElement },
  organizations: { title: 'Doanh nghiệp', href: Routes.ORGANIZATION, icon: <HiOfficeBuilding style={{ fontSize: '16px' }} /> as ReactElement },
  settings: { title: 'Cài đặt', icon: <AiOutlineSetting style={{ fontSize: '16px' }} /> as ReactElement },
};

export const getFallbackBreadcrumbs = (pathname: string): BreadcrumbProps['items'] => {
  if (!pathname || pathname === Routes.HOME || pathname === '/') {
    return null;
  }

  const items: BreadcrumbItem[] = [commonBreadcrumbs.home];

  if (pathname === Routes.PROJECT) {
    items.push({ title: 'Dự án', icon: commonBreadcrumbs.projects.icon });
  } else if (pathname.startsWith(Routes.PROJECT)) {
    items.push(commonBreadcrumbs.projects);
    items.push({ title: 'Chi tiết dự án' });
  } else if (pathname === Routes.ORGANIZATION) {
    items.push({ title: 'Doanh nghiệp', icon: commonBreadcrumbs.organizations.icon });
  } else if (pathname.startsWith(Routes.ORGANIZATION)) {
    items.push(commonBreadcrumbs.organizations);
    if (pathname.includes('/registration')) {
      items.push({ title: 'Thông tin đăng ký' });
    } else {
      items.push({ title: 'Chi tiết doanh nghiệp' });
    }
  } else if (pathname.startsWith(Routes.FREE_PHOTOS)) {
    items.push({ title: 'Ảnh tự do' });
  } else if (pathname.startsWith(Routes.TRANSFER_TO_MOBILE)) {
    items.push({ title: 'Truyền tệp' });
  } else if (pathname === Routes.COLLECT_FORMS) {
    items.push({ title: 'Biểu mẫu' });
  } else if (pathname === Routes.COLLECT_FORM_TEMPLATES) {
    items.push({ title: 'Template biểu mẫu' });
  } else if (
    pathname.startsWith(Routes.COLLECT_FORM_TEMPLATES) ||
    pathname.startsWith(Routes.FORM_BUILDER) ||
    pathname.includes('/design')
  ) {
    items.push({ title: 'Template biểu mẫu', href: Routes.COLLECT_FORM_TEMPLATES });
    if (pathname.includes('/design')) {
      items.push({
        title:
          pathname === Routes.COLLECT_FORM_TEMPLATE_DESIGN || pathname === Routes.COLLECT_FORM_DESIGN
            ? 'Thiết kế biểu mẫu'
            : 'Chỉnh sửa biểu mẫu',
      });
    } else {
      items.push({ title: pathname.includes('/new') ? 'Tạo mới' : 'Chỉnh sửa biểu mẫu' });
    }
  } else if (pathname.startsWith(Routes.SETTING)) {
    items.push({ title: 'Cài đặt', icon: commonBreadcrumbs.settings.icon });
  } else if (pathname.startsWith(Routes.PROFILE)) {
    items.push({ title: 'Thông tin cá nhân', icon: commonBreadcrumbs.settings.icon });
  } else if (pathname.startsWith(Routes.UPLOAD_TASK)) {
    items.push({ title: 'Lượt tải lên', icon: commonBreadcrumbs.uploadTasks.icon });
  } else if (pathname.startsWith(Routes.DIRECTORIES)) {
    items.push({ title: 'Thư mục' });
  } else if (pathname.startsWith(Routes.MAP_LAYERS)) {
    items.push({ title: 'Lớp bản đồ' });
  } else if (pathname.startsWith(Routes.PROJECT_3D)) {
    items.push({ title: 'Dự án 3D' });
  }

  return createBreadcrumbItems(items);
};